var _excluded = ["children", "items", "reverse"];

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import CardGroup from "../Card/CardGroup";
import SummaryBoxItem from "./SummaryBoxItem";
var defaultProps = {
  reverse: true
};

var SummaryBox = function SummaryBox(_ref) {
  var children = _ref.children,
      items = _ref.items,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? defaultProps.reverse : _ref$reverse,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(CardGroup, props, items ? items.map(function (item, i) {
    return /*#__PURE__*/React.createElement(SummaryBoxItem, {
      key: item.key || i,
      value: item.value,
      label: item.label,
      reverse: reverse
    });
  }) : children);
};

SummaryBox.displayName = "SummaryBox";
SummaryBox.displayName = 'SummaryBox';
SummaryBox.defaultProps = defaultProps;
export default SummaryBox;